import { cprValidation } from '.'

const inputHelper = {
    validate: (values, registrations) => {

        let errors = {};

        console.log('-------------- VALUES: ', values)
        console.log('-------------- validations: ', registrations)

        for (const prop in registrations) {
            if (registrations[prop] === undefined) {
                continue;
            }

            //If input is not required
            if (!registrations[prop].required.value) {
                if (!registrations[prop].pattern.value.test(values[prop])) {
                    errors[prop] = registrations[prop].pattern.message;
                }
                continue;
            }

            //If input is required
            if (!values[prop]) {
                errors[prop] = registrations[prop].required.message
            } else if (!registrations[prop].pattern.value.test(values[prop])) {
                errors[prop] = registrations[prop].pattern.message;
            }

            //If it's cpr inptut

            if (registrations['Cpr']) {
                values.Cpr && !cprValidation(values.Cpr) ? errors["Cpr"] =  registrations["Cpr"].pattern.message : " "                           
            }

        }

        return errors;
    },

    cprNumber: {
        preCprNumber: '',

        format: (cprNumber) => {
            const dash = '-'

            if (inputHelper.cprNumber.preCprNumber.length > cprNumber.length && inputHelper.cprNumber.preCprNumber.length === 7) {
                inputHelper.cprNumber.preCprNumber = cprNumber.substring(0, cprNumber.length - 1);

                return inputHelper.cprNumber.preCprNumber
            }

            else if (cprNumber.length >= 6) {
                let tempStr = "";

                for (let i = 0; i < cprNumber.length; i++) {
                    const char = cprNumber[i];
                    
                    tempStr += char;

                    if (cprNumber.length >= 6 && cprNumber.charAt(5) !== dash && cprNumber.charAt(6) !== dash && i == 5) {
                        tempStr += dash
                    }
                }

                //Limit maximum 11 characters
                if (tempStr.length > 11) {
                    cprNumber = '';
                    for (let i = 0; i < 11; i++) {
                        const char = tempStr[i];
                        
                        cprNumber += char;
                    }
                } else {
                    cprNumber = tempStr;
                }
            }

            inputHelper.cprNumber.preCprNumber = cprNumber;

            return cprNumber;
        }
    }
}

export default inputHelper;